import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import Select, { ValueType } from 'react-select';
import { Button, Form, Input } from 'reactstrap';
import { Dispatch } from 'redux';
import { Server } from '../../clients/aasServerClient.generated';
import { isLoading } from '../../stores/navigation/selectors';
import {
    clearSingleServer, copySingleServer,
    createSingleServer, newSingleServer
} from '../../stores/servers/actionCreators';
import { getSingleServer } from '../../stores/servers/selectors';
import { RootState } from '../../stores/store';
import SideModal from '../common/modals/SideModal';
import { LoadingButton } from '../navigation/LoadingButton';
import LoadingScreen from '../navigation/LoadingScreen';
import ServerProperties from './ServerProperties';

interface Props extends LocalizeContextProps, RouteComponentProps<{ id: string | undefined }> {
    isLoading: boolean;
    server: {
        loaded: boolean;
        saved: boolean;
        server?: Partial<Server>;
    };

    copySingleServer: (id: string) => void;
    newSingleServer: () => void;
    clearSingleServer: () => void;
    createSingleServer: (
        server: Partial<Server>,
    ) => void;
}

interface State {
    server?: Partial<Server>;

    isCopy: boolean;
}

class NewServerPage extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        const id = this.props.match.params.id;
        if (id) {
            this.state = {
                isCopy: true,
                server: undefined,
            };
            this.props.clearSingleServer();
            this.props.copySingleServer(id);
        } else {
            this.state = {
                isCopy: false,
                server: undefined,
            };
            this.props.clearSingleServer();
            this.props.newSingleServer();
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (!prevProps.server.loaded && this.props.server.loaded) {
            this.setState({
                server: this.props.server.server,
            });
        }
        if (!prevProps.server.saved && this.props.server.saved) {
            this.closePage();
        }
    }
    public modalRef = React.createRef<HTMLDivElement>();
    public render() {
        const t = this.props.translate;
        return (
            <SideModal
                isOpen={true}
                toggle={this.closePage}
                headerText={this.state.isCopy ? t('servers.edit.header.copy') as string
                    : t('servers.edit.header.add') as string}
                footer={this.renderFooter()}
                objectRef={this.modalRef}
                
            >
                {this.props.server.loaded && this.props.server.server ? (
                    <Form>
                        <h3 className="mb-4 mt-2">{t('servers.edit.section.details')}</h3>
                        <ServerProperties
                            type="new"
                            server={this.props.server.server}
                            updateServer={this.updateServer}
                        />
                    </Form>
                ) : (
                        <LoadingScreen text={t('loading.loading') as string} />
                    )}
            </SideModal>
        );
    }

    private updateServer = (server: Partial<Server>) => {
        this.setState({
            server,
        });
    }

    private closePage = () => {
        this.props.history.push('/servers');
    }

    private renderFooter = (): React.ReactNode => {
        const t = this.props.translate;
        return (
            <React.Fragment>
                <LoadingButton
                    loading={this.props.isLoading}
                    color="success"
                    onClick={this.createServer}
                    style={{ width: '200px' }}
                >
                    {t('servers.edit.button.save')}
                </LoadingButton>
            </React.Fragment>
        );
    }

    private createServer = () => {
        const server = this.state.server;

        this.props.createSingleServer(server!);
    }
}

const mapStateToProps = (state: RootState) => ({
    isLoading: isLoading(state),
    server: getSingleServer(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    clearSingleServer: () => dispatch(clearSingleServer()),
    copySingleServer: (id: string) => dispatch(copySingleServer(id)),
    createSingleServer: (
        server: Partial<Server>,
    ) => dispatch(createSingleServer(server)),
    newSingleServer: () => dispatch(newSingleServer()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLocalize(NewServerPage)));